<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormAd @submit="submit" :title="'Update Ad'" :form="form" :mode="'edit'"></FormAd>
      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            Preview
          </div>
          <b-card-body>
            <div v-if="form.type==='image'">
              <a :href="form.link" target="_blank"><img :src="`${mobileUrl}/img/uploads/${form._id}.${form.imageExt}`" class="responsive"></a>
            </div>
            <div v-if="form.type==='html'" class="preview-window">
              <div v-html="form.html"></div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormAd from '@/views/ads/FormAd'
import axios from 'axios'

export default {
  name: 'updatead',
  components: {
    FormAd
  },  
  data () {
    return {
      form: {}
    }
  },
  computed: {
    id: function () {
      return this.$route.params.id
    },
    mobileUrl () {
      return process.env.VUE_APP_MOBILE_URL;
    }
  },
  methods: {
    submit (form) {
      let scope = this; 

      form._id = scope.id;
      form.user = scope.$store.getters.currentUser.id

      axios.put(process.env.VUE_APP_API + '/ad/' + form._id, form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          
          
          if(form.type === 'image') {

            let formData = new FormData();

            if(form.file) {

              formData.append('file', form.file);
              formData.append('fileName', response.data._id);

              axios.post(process.env.VUE_APP_API + '/ad/upload',
                formData,
                {
                  headers: {
                      Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token'),
                      'Content-Type': 'multipart/form-data'
                  }
                }
              ).then(function(){
                scope.$router.push('/ads/list')
              })
              .catch(function(){
                console.log('Failed to upload file!!');
              });
              
            } else {
              scope.$router.push('/ads/list')  
            }

          } else  {
            scope.$router.push('/ads/list')
          }


        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  created () {
    let scope = this;
    axios.get(process.env.VUE_APP_API + '/ad/' + scope.id, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.form = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
